import React from "react";
import styles from "./SectionGallery.module.css";

import oso from "../data/assets/Amigurumis/Oso/0.png";
import ballena from "../data/assets/Amigurumis/Ballena/0.png";
import aang from "../data/assets/Anime/Avatar/Aang/aang-1.png";
import comida from "../data/assets/Llaveros/comida/japon-comida.png";
import flores from "../data/assets/Flores/girasol/girasol-1.png";

function SectionGallery({
  setShowGallery,
  setShowGalleryAmigurumis,
  setShowGalleryAnime,
  setShowGalleryChenille,
  setShowGalleryKeychain,
  setShowGalleryRandom,
}) {
  const dataSection = [
    {
      title: "Amigurumis",
      text: "Hilo 100% algodón",
      src: oso,
      onClick: () => {
        setShowGallery(false);
        setShowGalleryAmigurumis(true);
      },
    },
    {
      title: "Amigurumis de Chenille",
      text: "Textura aterciopelada, súper suavecito",
      src: ballena,
      onClick: () => {
        setShowGallery(false);
        setShowGalleryChenille(true);
      },
    },
    {
      title: "Anime y juegos",
      text: "Tu personaje favorito",
      src: aang,
      onClick: () => {
        setShowGallery(false);
        setShowGalleryAnime(true);
      },
    },
    {
      title: "Detalles únicos",
      text: "Lo hecho a mano es especial",
      src: flores,
      onClick: () => {
        setShowGallery(false);
        setShowGalleryRandom(true);
      },
    },
    {
      title: "Llaveros y colgantes",
      text: "Gatitos, unicornios, ballenitas, corazones...",
      src: comida,
      onClick: () => {
        setShowGallery(false);
        setShowGalleryKeychain(true);
      },
    },
  ];
  return (
    <div className={styles.selectGallery}>
      {dataSection.map((item, i) => (
        <div className={styles.container} key={i}>
          <h2 className={styles.title}>{item.title}</h2>
          <p className={styles.text}>{item.text}</p>
          <button className={styles.item} onClick={item.onClick}>
            <img src={item.src} alt="Item" className={styles.photo}></img>
            <p className={styles.fig}>Ver</p>
          </button>
        </div>
      ))}
      ;
    </div>
  );
}

export { SectionGallery };
